import { render } from "./archived_staff_member.vue?vue&type=template&id=b9cc887a&scoped=true"
import script from "./archived_staff_member.vue?vue&type=script&lang=js"
export * from "./archived_staff_member.vue?vue&type=script&lang=js"

import "./archived_staff_member.vue?vue&type=style&index=0&id=b9cc887a&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9cc887a"]])

export default __exports__